import * as React from "react";

import { PresenterForScrollProvider, ProminentErrorProvider } from "../Common";

import {
  ContentRouteProvider,
  ForgotPasswordFormProvider,
  ReactForgotPasswordInitialStateProvider,
} from "./providers";

import { Page } from "./Page";

interface AppProps {
  mountElement: Element;
}

export const App: React.FunctionComponent<AppProps> = (props) => {
  return (
    <ProminentErrorProvider>
      <PresenterForScrollProvider>
        <ContentRouteProvider>
          <ReactForgotPasswordInitialStateProvider
            mountElement={props.mountElement}
          >
            <ForgotPasswordFormProvider>
              <Page />
            </ForgotPasswordFormProvider>
          </ReactForgotPasswordInitialStateProvider>
        </ContentRouteProvider>
      </PresenterForScrollProvider>
    </ProminentErrorProvider>
  );
};
